
import { Options, Vue } from "vue-class-component";
import AppButton from "@/components/common/AppButton.vue";

import FeeBalanceInfo from "@/components/turret/fee-balance/FeeBalanceInfo.vue";
import XdrTokenForm from "@/components/turret/xdr-token/XdrTokenForm.vue";
import AppInput from "@/components/common/form/AppInput.vue";
import PaymentInfo from "@/components/turret/payment/PaymentInfo.vue";
import scrollToBottom from "@/helpers/domHelper";
import IFeeBalance from "@/entities/IFeeBalance";
import FeeBalance from "@/entities/FeeBalance";
import Payment from "@/entities/Payment";
import IPayment from "@/entities/IPayment";
import TurretHttpError from "@/errors/TurretHttpError";
import {
  fundTurret,
  generateXdr,
  getFeeBalance,
} from "@/services/turret/turret";

@Options({
  components: {
    FeeBalanceInfo,
    AppInput,
    XdrTokenForm,
    AppButton,
    PaymentInfo,
  },
})
export default class ManageTurretFunds extends Vue {
  private feeBalance: IFeeBalance = FeeBalance.createNull();
  private xdrToken = "";
  private payment: IPayment = Payment.createNull();
  private fetchError = "";
  private paymentError = "";
  private isFetching = false;
  private isCreatingXdr = false;
  private isProcessingPayment = false;
  private publicKeyToFund = "";

  async createXdr(): Promise<void> {
    try {
      const turret = this.$store.state.turret;
      const keyPair = this.$store.getters.keypair;
      this.isCreatingXdr = true;
      this.xdrToken = await generateXdr(turret, keyPair, "true", 3590, []);
      await this.fetchTransactionFee();
    } catch (e) {
      console.error(e);
    } finally {
      this.isCreatingXdr = false;
    }
  }

  async fetchTransactionFee(xdrToken?: string): Promise<void> {
    this.isFetching = true;
    this.fetchError = "";
    this.feeBalance = FeeBalance.createNull();

    const turret = this.$store.state.turret;
    try {
      this.feeBalance = await getFeeBalance(turret, xdrToken ?? this.xdrToken);
    } catch (e) {
      this.fetchError = e instanceof TurretHttpError ? e.json : e;
    }

    this.isFetching = false;
    await this.$nextTick(scrollToBottom);
  }

  async handleFundingFromFeeBalanceInfo(
    xdrToken: string,
    amount: string
  ): Promise<void> {
    this.isProcessingPayment = true;
    this.paymentError = "";
    const kp = this.$store.getters.keypair;
    const turret = this.$store.state.turret;
    try {
      this.payment = await fundTurret(turret, kp.publicKey(), kp, amount);
    } catch (e) {
      this.paymentError = e instanceof TurretHttpError ? e.json : e;
    }

    await this.fetchTransactionFee(xdrToken);
    this.isProcessingPayment = false;
    await this.$nextTick(scrollToBottom);
  }

  async handleFundingPublicKey(amount: string): Promise<void> {
    this.isProcessingPayment = true;
    this.paymentError = "";
    try {
      this.payment = await fundTurret(
        this.$store.state.turret,
        this.publicKeyToFund,
        this.$store.getters.keypair,
        amount
      );
    } catch (e) {
      this.paymentError = e instanceof TurretHttpError ? e.json : e;
    }

    this.isProcessingPayment = false;
    await this.$nextTick(scrollToBottom);
  }
}
